import React, { createContext, useContext, useState } from 'react'

const CartContext = createContext()

export function CartProvider({ children }) {
  const [cart, setCart] = useState([])

  const addItem = (product) => {
    if (product && product.hasOwnProperty('disponivel') && !product.disponivel) {
      // Evita adicionar itens marcados como indisponíveis
      const event = new CustomEvent('toast', {
        detail: { message: `${product.nome || 'Produto'} indisponível`, type: 'error' }
      })
      window.dispatchEvent(event)
      return
    }
    setCart(prev => [...prev, product])
  }

  const removeItem = (productId) => {
    setCart(prev => prev.filter(item => item.id !== productId))
  }

  const clearCart = () => {
    setCart([])
  }

  return (
    <CartContext.Provider value={{ cart, addItem, removeItem, clearCart }}>
      {children}
    </CartContext.Provider>
  )
}

export function useCart() {
  const context = useContext(CartContext)
  if (!context) {
    throw new Error('useCart must be used within a CartProvider')
  }
  return context
}
